import React from "react";

export function isAllowedDomain(): boolean {
  const currentHost = window.location.hostname;
  return (
    currentHost === "cstry2.web.app" ||
    currentHost === "localhost" ||
    currentHost === "127.0.0.1" ||
    currentHost.includes("athtest")
  );
}

export const UnsupportedDomainCard: React.FC = () => {
  const handleRedirectToCorrectDomain = () => {
    window.location.href = "https://cstry2.web.app";
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
        padding: "20px",
      }}
    >
      <div
        style={{
          backgroundColor: "white",
          borderRadius: "16px",
          boxShadow:
            "0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)",
          padding: "40px",
          maxWidth: "450px",
          width: "100%",
          textAlign: "center",
        }}
      >
        <div style={{ marginBottom: "24px" }}>
          <div
            style={{
              margin: "0 auto 16px",
              width: "64px",
              height: "64px",
              background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
              borderRadius: "50%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <svg
              style={{ width: "32px", height: "32px", color: "white" }}
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
              />
            </svg>
          </div>
          <h2
            style={{
              fontSize: "24px",
              fontWeight: "bold",
              color: "#1f2937",
              marginBottom: "8px",
            }}
          >
            Unsupported Domain
          </h2>
          <p
            style={{
              color: "#4b5563",
              marginBottom: "4px",
              fontSize: "16px",
            }}
          >
            You're accessing Arthereum Wallet from an unsupported domain.
          </p>
          <p
            style={{
              fontSize: "14px",
              color: "#6b7280",
            }}
          >
            For a better experience, please use cstry2.web.app
          </p>
        </div>

        <div
          style={{
            background: "linear-gradient(135deg, #fef3c7 0%, #fde68a 100%)",
            borderRadius: "12px",
            padding: "20px",
            marginBottom: "24px",
          }}
        >
          <p
            style={{
              fontSize: "14px",
              fontWeight: "500",
              color: "#92400e",
              marginBottom: "4px",
            }}
          >
            Official Domain
          </p>
          <p
            style={{
              fontSize: "20px",
              fontWeight: "bold",
              color: "#78350f",
              letterSpacing: "0.5px",
            }}
          >
            cstry2.web.app
          </p>
        </div>

        <button
          onClick={handleRedirectToCorrectDomain}
          style={{
            width: "100%",
            background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
            color: "white",
            fontWeight: "600",
            padding: "14px 24px",
            borderRadius: "10px",
            border: "none",
            cursor: "pointer",
            fontSize: "16px",
            transition: "transform 0.2s, box-shadow 0.2s",
            boxShadow:
              "0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)",
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.transform = "translateY(-2px)";
            e.currentTarget.style.boxShadow =
              "0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.transform = "translateY(0)";
            e.currentTarget.style.boxShadow =
              "0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)";
          }}
        >
          Go to Arthereum
        </button>
      </div>
    </div>
  );
};

interface DomainGuardProps {
  children: React.ReactNode;
}

export const DomainGuard: React.FC<DomainGuardProps> = ({ children }) => {
  if (!isAllowedDomain()) {
    return <UnsupportedDomainCard />;
  }

  return <>{children}</>;
};

export default DomainGuard;
